import axios from 'axios'

export default {
    namespaced: true,
    state:{
        roles: []
    },
    mutations: {
        GET_ROLES(state, payload){
            state.roles = payload
        },
    },
    actions: {
        roles({ commit, getters }) {
            return new Promise((resolve, reject) => {
                axios.get('role')
                .then(res => {
                    commit('GET_ROLES', res.data.data)
                    resolve(res.data.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        show({ commit, getters }, _id) {
            return new Promise((resolve, reject) => {
                axios.get(`role/${_id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response)
                })
            })
        },
        store({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.post('role', formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        update({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.put(`role/${formData._id}`, formData)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        updatePermission({ commit, getters }, formData) {
            return new Promise((resolve, reject) => {
                axios.put(`role/update/${formData.roleId}/permission`, formData.request)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
        destroy({ commit, getters }, id) {
            return new Promise((resolve, reject) => {
                axios.delete(`role/${id}`)
                .then(res => {
                    resolve(res.data)
                })
                .catch(error => {
                    reject(error.response.data)
                })
            })
        },
    }
}